import {TheBorderSymbol} from "./TheBorderSymbol";
import {TheBorder} from "../TheBorder";
import {TheBorderGameAssets} from "../TheBorderGameAssets";
import {gsap} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TheBorderStatics} from "../TheBorderStatics";

/**
 * Created by Jerker Nord on 2022-05-12.
 */

export class TheBorderXWaysSymbol extends TheBorderSymbol {

    public static LANDING_ANIMATION:string = "landing";
    public static EXPAND_UP:string = "up_expand";
    public static EXPAND_DOWN:string = "down_expand";
    public static EXPAND_UP_AND_DOWN:string = "mid_expand";
    public static EXPAND_UP_FAST:string = "up_expand_reveal";
    public static EXPAND_DOWN_FAST:string = "down_expand_reveal";
    public static EXPAND_UP_AND_DOWN_FAST:string = "mid_expand_reveal";
    public static MID_REVEAL:string = "mid_reveal";
    public static REVEAL:string = "reveal";
    public static REVEAL_NO_ROOM:string = "reveal_n";

    private _landingTL:gsap.core.Timeline;
    private _expandUpTL:gsap.core.Timeline;
    private _revealUpTL:gsap.core.Timeline;
    private _expandDownTL:gsap.core.Timeline;
    private _revealDownTL:gsap.core.Timeline;
    private _revealNoRoom:gsap.core.Timeline;
    private _expandUpAndDownTL:gsap.core.Timeline;
    private _revealUpAndDownTL:gsap.core.Timeline;
    private _expandAndRevealUpTL:gsap.core.Timeline;
    private _expandAndRevealDownTL:gsap.core.Timeline;
    private _expandAndRevealUpAndDownTL:gsap.core.Timeline;

    constructor() {
        super();
        this.symbolName = "X_WAYS";
        this.createAnimations();
    }

    public getLandingAnimation():gsap.core.Timeline {
        this.topLayerContainer.position.x = (TheBorderStatics.symbolWidth * this.reelId);
        this.topLayerContainer.position.y = this.y;
        TheBorder.allReelsView.addChild(this.topLayerContainer);
        return this._landingTL;
    }

    public getExpandAndRevealUpTL():gsap.core.Timeline {
        return this._expandAndRevealUpTL;
    }

    public getExpandAndRevealDownTL():gsap.core.Timeline {
        return this._expandAndRevealDownTL;
    }

    public getExpandUpAnimation():gsap.core.Timeline {
        return this._expandUpTL;
    }

    public getExpandAndRevealUpAndDownTL():gsap.core.Timeline {
        return this._expandAndRevealUpAndDownTL;
    }

    public getRevealUpAnimation():gsap.core.Timeline {
        return this._revealUpTL;
    }

    public getExpandDownAnimation():gsap.core.Timeline {
        return this._expandDownTL;
    }

    public getRevealDownAnimation():gsap.core.Timeline {
        return this._revealDownTL;
    }

    public getRevealNoRoomAnimation():gsap.core.Timeline {
        return this._revealNoRoom;
    }

    public getExpandUpAndDownAnimation():gsap.core.Timeline {
        return this._expandUpAndDownTL;
    }

    public getRevealUpAndDownAnimation():gsap.core.Timeline {
        return this._revealUpAndDownTL;
    }

    public turnOffSymbolSpine():void {
        if(this._landingTL && this._landingTL.isActive()) {
            this._landingTL.pause();
            this._landingTL.kill();
        }
        this._spineAnimation.visible = false;
    }

    public reset():void {
        this.symbolName = "X_WAYS";
        super.reset();
    }

    private createAnimations():void {
        this._spineAnimation = new PIXI.spine.Spine(TheBorder.assetLoader.getSpineAsset(TheBorderGameAssets.X_WAYS_SPINE));
        this._spineAnimation.visible = false;
        this._spineContainer.addChild(this._spineAnimation);
        this.topLayerContainer.addChild(this._spineContainer);

        this._landingTL = gsap.timeline({paused : true});
        this._landingTL.add(() => {
            this._spineAnimation.y = 0;
            this.prepareSpine();
            this.visible = false;
        });
        this._landingTL.add(new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.LANDING_ANIMATION));

        this._expandUpTL = gsap.timeline({paused : true});
        this._expandUpTL.add(() => {
            this.prepareSpine();
        });
        this._expandUpTL.add([
            new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.EXPAND_UP),
            gsap.timeline({delay : 0.2}).add(() => {this._spineAnimation.position.y = -50})
        ]);

        this._revealUpTL = gsap.timeline({paused : true});
        this._revealUpTL.add(() => {
            this._spineAnimation.y = 50;
            this.prepareSpine();
        });
        this._revealUpTL.add([
            new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.REVEAL)
        ]);
        this._revealUpTL.add(() => {this._spineAnimation.visible = false});
        this._revealUpTL.add(() => {this.visible = true}, "-=0.1");

        this._expandDownTL = gsap.timeline({paused : true});
        this._expandDownTL.add(() => {
            this._spineAnimation.y = 0;
            this.prepareSpine();
        });
        this._expandDownTL.add(new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.EXPAND_DOWN));

        this._revealDownTL = gsap.timeline({paused : true});
        this._revealDownTL.add(() => {
            this.prepareSpine();
        });
        this._revealDownTL.add(new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.REVEAL));
        this._revealDownTL.add(() => {this._spineAnimation.visible = false});
        this._revealDownTL.add(() => {this.visible = true}, "-=0.1");

        this._revealNoRoom = gsap.timeline({paused : true});
        this._revealNoRoom.add(() => {
            this.prepareSpine();
        });
        this._revealNoRoom.add(new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.REVEAL_NO_ROOM));
        this._revealNoRoom.add(() => {this._spineAnimation.visible = false});
        this._revealNoRoom.add(() => {this.visible = true}, "-=0.1");

        this._expandUpAndDownTL = gsap.timeline({paused : true});
        this._expandUpAndDownTL.add(() => {
            this._spineAnimation.y = 0;
            this.prepareSpine();
        });
        this._expandUpAndDownTL.add(() => this.hide());
        this._expandUpAndDownTL.add(new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.EXPAND_UP_AND_DOWN));

        this._revealUpAndDownTL = gsap.timeline({paused : true});
        this._revealUpAndDownTL.add(() => {
            this.prepareSpine();
        });
        this._revealUpAndDownTL.add(new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.MID_REVEAL));
        this._revealUpAndDownTL.add(() => {this._spineAnimation.visible = false});
        this._revealUpAndDownTL.add(() => {this.visible = true}, "-=0.1");

        this._expandAndRevealUpTL = gsap.timeline({paused : true});
        this._expandAndRevealUpTL.add(() => {
            this.prepareSpine();
        });
        this._expandAndRevealUpTL.add([
            new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.EXPAND_UP_FAST),
            gsap.timeline({delay : 0.2}).add(() => {this._spineAnimation.position.y = -50})
        ]);
        this._expandAndRevealUpTL.add(() => {this._spineAnimation.visible = false});
        this._expandAndRevealUpTL.add(() => {this.visible = true}, "-=0.1");
        this._expandAndRevealUpTL.add(() => {this._spineAnimation.position.y = 0});

        this._expandAndRevealDownTL = gsap.timeline({paused : true});
        this._expandAndRevealDownTL.add(() => {
            this.prepareSpine();
        });
        this._expandAndRevealDownTL.add(new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.EXPAND_DOWN_FAST));
        this._expandAndRevealDownTL.add(() => {this._spineAnimation.visible = false});
        this._expandAndRevealDownTL.add(() => {this.visible = true}, "-=0.1");

        this._expandAndRevealUpAndDownTL = gsap.timeline({paused : true});
        this._expandAndRevealUpAndDownTL.add(() => {
            this.prepareSpine();
        });
        this._expandAndRevealUpAndDownTL.add(new SpineTween(this._spineAnimation, 0, TheBorderXWaysSymbol.EXPAND_UP_AND_DOWN_FAST));
        this._expandAndRevealUpAndDownTL.add(() => {this._spineAnimation.visible = false});
        this._expandAndRevealUpAndDownTL.add(() => {this.visible = true}, "-=0.1");
    }

    private prepareSpine():void {
        this._spineAnimation.state.clearTracks();
        if(!this._spineAnimation.visible) {
            this._spineAnimation.visible = true;
            this._spineAnimation.updateTransform();
        }
        this._spineAnimation.skeleton.setSlotsToSetupPose();
        this._spineAnimation.skeleton.setToSetupPose();
        this._spineAnimation.state.setEmptyAnimation(0, 0);
    }
}